import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasMessages)?_c(VContainer,[_vm._l((_vm.systemMessages),function(message,i){return _c('a-alert',{key:i,staticClass:"mt-4",attrs:{"message":message.message,"type":message.type,"dismissible":""}})}),(!_vm.systemMessages.length)?_vm._t("default"):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }